import FeaturedList from './FeaturedList';
import FeaturedListContainer from './FeaturedList.container';
export default FeaturedListContainer(FeaturedList);
